module.exports = __webpack_public_path__ + "static/media/snoopychristmas.536476cd.gif";